import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { ROMAN_MAX_OPTIONS, RomanQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two Roman numeral dials (ADR 0079 §2 and §4).
 *
 * The question type says which way the conversion runs, and the largest number
 * is the difficulty: ten is I to X, and 3999 is the most standard numerals can
 * write. The operator bar is hidden for this format - a numeral is converted,
 * not combined with another.
 */
export function RomanSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: RomanQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, RomanQuestion: value });
    }

    function handleMaxChange(event) {
        setSettings({ ...settings, RomanMax: Number(event.target.value) });
    }

    return (
        <div className="romanSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.RomanQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(RomanQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.largestNumberLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.largestNumberAria')}>
                {ROMAN_MAX_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`romanMax-${option}`}
                            value={option}
                            checked={settings.RomanMax === option}
                            onChange={handleMaxChange}
                        />
                        <label htmlFor={`romanMax-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default RomanSettings;
